module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-t-mobile-01@2x.ea6fb75d.jpg";